module.exports = __webpack_public_path__ + "a10b9c9aa57e7230f705161b524e0890.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Off-White_Big_RGB.png
// module id = 185
// module chunks = 0